module.exports = {
    "breadcrumbs": `Caminho detalhado`
};


//# sourceMappingURL=pt-BR.main.js.map
